import { ChangeEventArgs, Switch } from '@syncfusion/ej2-buttons';

import { routes } from '@/shared/routes';
import { EditableClientProps, EditableRequestBody } from '@/shared/types/editable';

import { input } from '@/front/editable/input';
import { addValidation, maybeNegate, setControl } from '@/front/editable/state';
import { change } from '@/front/editable/utils';
import { POST } from '@/front/fetch';

export const initSwitch = (p: EditableClientProps, e: HTMLElement) => {
  const swtch = new Switch({
    checked: maybeNegate(p, p.value),
    disabled: p.readOnly,
  });

  if (!p.modelId || p.editMode === 'Form') {
    swtch.change = change(e);

    setControl(p.id, swtch);

    addValidation(p, e);

    swtch.appendTo(input(p, e));
  } else {
    swtch.change = async (args: ChangeEventArgs) => {
      const body: EditableRequestBody = {
        params: {
          name: p.field,
          primaryKey: p.modelId,
          value: maybeNegate(p, args.checked),
        },
      };

      await POST(routes.data.editable({ model: p.modelName }), body);
    };

    swtch.appendTo(e);
  }
};
